<?php

Namespace Model\UserAccount;

class PageModel extends \Model\Base
{
    public $returned_data;

    public static function getPage()
    {
        $page = array();
        $page['title'] = 'Manage your Video Interviews Account';
        $page['heading'] = 'Your Interview list in Video Interviews';
        \ISOPHP\js_core::$console->log('UserAccount Mod', $page);
        return $page;
    }

    public function showInterviewList($pageVars)
    {
        return function () use ($pageVars) {
            \ISOPHP\js_core::$console->log('Showing Interview List');
            $vars['control'] = 'Account';
            $vars['action'] = 'interview';

            $vars['api_uri'] = '/api/get_my_interviews';

            $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
            \ISOPHP\js_core::$console->log('Logged user at Interview List: ', $user_logged);
            $vars['user_id'] = isset($user_logged['id']) ? $user_logged['id'] : '';

            $afterwards = $this->applyInterviewListResult($pageVars);
            $result = $this->performRequest($vars, $afterwards, true);
            \ISOPHP\js_core::$console->log('InterviewList Model: ', $result);
            return $result;
        };
    }

    public function applyInterviewListResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            \ISOPHP\js_core::$console->log('applying our Interview List result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $vars = array();
                $vars['params'] = $pageVars['params'];
                $vars['request_data'] = $request_data;
                \ISOPHP\js_core::$console->log('apply Job List 1', $vars);
                $view = new \View\UserAccountView();
                $view->loadTemplate('UserAccount', 'UserAccountInterviews.php', $vars);
                $bind = self::bindButtons();
                $view->displayAccount($bind);
                \ISOPHP\js_core::$console->log('apply Job List 2', $vars);
            }
            if ($request_data['status'] !== 'OK') {
                \ISOPHP\js_core::$console->log('Job List failed');
            }
        };
        return $func;
    }

    public function showLastLogin($pageVars)
    {
        return function () use ($pageVars) {
            \ISOPHP\js_core::$console->log('Showing Last Login');
            $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
            \ISOPHP\js_core::$console->log('Logged user at home summary: ', $user_logged);
            $last_login = $user_logged['last_login'];
            $jQuery = \ISOPHP\js_core::$jQuery;
            $login_date = \ISOPHP\core::$php->date('l, d/m/Y', $last_login);
            $login_time = \ISOPHP\core::$php->date('H:i:s', $last_login);
            $jQuery('#latest-login-date')->html($login_date);
            $jQuery('#latest-login-time')->html($login_time);

//            \ISOPHP\js_core::$console->log('HomeSummary Account Model: ') ;
            return true;
        };
    }

    public static function bindButtons()
    {
        return function () {
            if (ISOPHP_EXECUTION_ENVIRONMENT === 'UNITER') {
                \ISOPHP\js_core::$console->log('Binding buttons');
                $navigate = new \Model\Navigate();
                $jQuery = \ISOPHP\js_core::$jQuery;
                $go_landing_page = $jQuery('#go-landing-page');
                $go_landing_page->on('click', function ($jqThis) use ($navigate) {
                    $jqThis->preventDefault();
                    $navigate->route('LandingPage', 'show', array(), '/');
                });
                $go_home_page = $jQuery('#go-home-page');
                $go_home_page->on('click', function ($jqThis) use ($navigate) {
                    $jqThis->preventDefault();
                    $navigate->route('Home', 'show', array(), '/home');
                });
            }
        };
    }

}


// WEBPACK FOOTER //
// app/UserAccount/Model/UserAccountPageModel.php